module.exports = __webpack_public_path__ + "icon-truck.82bccd83fb1e579767ddc790b3a46d51.svg";